import { useTranslation } from 'next-i18next';
import { useAutoConfirmCountdown } from '@/shared/hooks';
import { openOverlayOnce } from '@/shared/utils/openOverlayOnce';
import { AlertDialog } from '@/ui_v3';

/** 확인을 누르지 않아도 로그인으로 이동하기까지의 시간. */
const AUTH_EXPIRED_REDIRECT_SECONDS = 5;

/** 만료 모달은 동시에 하나만 존재한다. */
const AUTH_EXPIRED_OVERLAY_ID = 'ai-builder-auth-expired';
interface AiBuilderAuthExpiredDialogProps {
  /** 확인 버튼 클릭 또는 카운트다운 종료 시 호출된다 (로그인 리다이렉트). */
  onConfirm: () => void;
  /** 자동 이동까지 남은 시간(초). */
  seconds?: number;
}
function AiBuilderAuthExpiredDialog({
  onConfirm,
  seconds = AUTH_EXPIRED_REDIRECT_SECONDS
}: AiBuilderAuthExpiredDialogProps) {
  const {
    t
  } = useTranslation(['build', 'common']);
  const {
    secondsLeft
  } = useAutoConfirmCountdown({
    seconds,
    onExpire: onConfirm
  });
  return <AlertDialog
  // hasCloseButton 미지정 → X 없음. shouldCloseOnDimClick=false → 백드롭 무시.
  // ESC 는 Radix Root 에 onOpenChange 가 물려있지 않아 애초에 닫히지 않는다.
  // 남는 종료 경로는 확인 버튼뿐이고, 그게 곧 로그인 이동이다.
  onClose={onConfirm} shouldCloseOnDimClick={false} header={{
    title: t('common:loginRequired.title')
  }} body={t('build:aiBuilderChat.authExpired.body')} confirmText={t('common:loginRequired.confirm', {
    seconds: secondsLeft
  })} data-sentry-element="AlertDialog" data-sentry-component="AiBuilderAuthExpiredDialog" data-sentry-source-file="AiBuilderAuthExpiredDialog.tsx" />;
}

/**
 * 로그인 만료 안내 모달을 띄운다.
 *
 * unmount 하지 않는다 — 확인이 곧 하드 네비게이션이라 먼저 걷어내면 이동 직전에 뒷 화면이
 * 드러나고, 이동이 막히는 경우엔 모달이 남아 있는 편이 맞다.
 */
export function openAiBuilderAuthExpiredDialog(props: AiBuilderAuthExpiredDialogProps) {
  return openOverlayOnce(AUTH_EXPIRED_OVERLAY_ID, () => <AiBuilderAuthExpiredDialog {...props} />);
}